export const API_LOCAL_URL = "http://localhost:3001";
export const API_PROD_URL = "https://apiautorizacao.cieemg.org.br";
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1")
    ? API_LOCAL_URL
    : API_PROD_URL);

/**
 * Endpoints consumidos pela aplicação.
 *
 * Mantém compatibilidade com o formato já usado pelas páginas (callbacks
 * recebem o id) e adiciona endpoints auxiliares consumidos pela página
 * de Acompanhamento, alinhando a nomenclatura à API
 * api-autorizacao-estagio-aprendiz e espelhando os padrões usados no
 * projeto CadastroEmpresa.
 */
export const API_ENDPOINTS = {
  dashboard: `${API_BASE_URL}/dashboard`,
  tce: `${API_BASE_URL}/tce`,
  tca: `${API_BASE_URL}/tca`,
  tca_empregador: `${API_BASE_URL}/tca-empregador`,
  tce_upload: `${API_BASE_URL}/upload`,
  tca_upload: `${API_BASE_URL}/upload`,
  tce_empresa_autorizacao: (empresaId) =>
    `${API_BASE_URL}/tce/empresa/${empresaId}/autorizacao`,
  tca_empresa_autorizacao: (empresaId) =>
    `${API_BASE_URL}/tca/empresa/${empresaId}/autorizacao`,
  tca_id_aprovar: (id) => `${API_BASE_URL}/tca/${id}/aprovar`,
  tca_id_recusar: (id) => `${API_BASE_URL}/tca/${id}/recusar`,
  // Endpoint dedicado de acompanhamentos (mantido alinhado ao CadastroEmpresa).
  acompanhamentosMe: `${API_BASE_URL}/acompanhamentos/me`,
  inicial_tokens: `${API_BASE_URL}/tokens`,
  filial_id: (id) => `${API_BASE_URL}/filiais/${id}`,
  filial_update: (id) => `${API_BASE_URL}/filiais/${id}`,
  filial_list: `${API_BASE_URL}/filiais`,
  // Histórico de eventos do processo (auditoria).
  historico_eventos: `${API_BASE_URL}/historico-eventos`,
};
